'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Port of redux [`combineReducers`](http://rackt.org/redux/docs/api/combineReducers.html). The difference is though
 * that it's allowed to provide reducers as generators. Please, be aware that the function does not contain any
 * special sanity checks. The reason why is that this is quite specific implementation which should most likely
 * be in user land.
 *
 * @param {Map} Map of reducers, key will be used as key in the application state
 * @returns {Function} Single reducer
 */

exports.default = function (reducers) {
  var initialState = (0, _utils.mapObject)(reducers, function () {
    return undefined;
  });

  return _regenerator2.default.mark(function _callee2() {
    var state = arguments.length <= 0 || arguments[0] === undefined ? initialState : arguments[0];
    var action = arguments[1];
    var hasChanged, mutatedReduction;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            hasChanged = void 0;
            return _context2.delegateYield((0, _utils.generatorMapObject)(reducers, _regenerator2.default.mark(function _callee(reducer, key) {
              var previousKeyedReduction, nextKeyedReduction;
              return _regenerator2.default.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      previousKeyedReduction = state[key];
                      nextKeyedReduction = void 0;

                      if (!(0, _utils.isGenerator)(reducer)) {
                        _context.next = 7;
                        break;
                      }

                      return _context.delegateYield(reducer(previousKeyedReduction, action), 't0', 4);

                    case 4:
                      nextKeyedReduction = _context.t0;
                      _context.next = 8;
                      break;

                    case 7:
                      nextKeyedReduction = reducer(previousKeyedReduction, action);

                    case 8:

                      hasChanged = hasChanged || nextKeyedReduction !== previousKeyedReduction;
                      return _context.abrupt('return', nextKeyedReduction);

                    case 10:
                    case 'end':
                      return _context.stop();
                  }
                }
              }, _callee, this);
            })), 't0', 2);

          case 2:
            mutatedReduction = _context2.t0;
            return _context2.abrupt('return', hasChanged ? mutatedReduction : state);

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, this);
  });
};